export default {
  setDescuentosArray(state,d){
    state.descuentosArray = d;
  }
}